import { IconButton, ChevronLeftIcon, ChevronRightIcon } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import React from 'react';
import { translation, TranslationsContext } from '../../../../../../../../Translations';

interface Props {
  direction: 'left' | 'right';
  onClick: () => void;
  disabled?: boolean;
}

function ScrollButton({ direction, onClick, disabled = false }: Props) {
  const ts = React.useContext(TranslationsContext);
  const Icon = direction === 'left' ? ChevronLeftIcon : ChevronRightIcon;
  const ariaLabel =
    direction === 'left' ? translation('Scroll left')(ts) : translation('Scroll right')(ts);

  return (
    <IconButton
      className={`w-[30px] items-center text-font-size-4xl lg:w-10 transition-opacity ${disabled ? 'opacity-30 cursor-not-allowed' : 'opacity-100'}`}
      onClick={disabled ? undefined : onClick}
      aria-label={ariaLabel}
      aria-disabled={disabled}
      data-intercom-target={`builder-v2-carousel-scroll-${direction}`}
    >
      <Icon color="black" size="xl" />
    </IconButton>
  );
}

export default observer(ScrollButton);
